import { css } from "@styled-system/css";
import { stack } from "@styled-system/patterns";

export const formWrapperClass = stack({
	gap: "12",
	width: "full",
	marginX: "auto",
});

export const inputsWrapperClass = stack({
	gap: "12",
});

export const invitationTitleWrapperClass = stack({
	gap: "12",
	marginBottom: "12",
});

export const textCenterClass = css({
	marginX: "auto",
	textAlign: "center",
});
